import React, { useEffect, useState } from "react";
import {
  Alert,
  Modal,
  Button,
  Card,
  Spinner,
  Row,
  Col,
  Form,
  Table,
  Tooltip,
  OverlayTrigger,
  Dropdown,
} from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import toastr from "toastr";
import { getAreasJerarquia } from "../../redux/areasfuncional/actions";
import SearchOrganizationalUnit from "../descriptorsProfiles/SearchOrganizationalUnit";
import { getEmployees } from "../../redux/climalaboral/segment/actions";

const Employees = (props) => {
  //filtros
  const filters = [
    { id: "codigo", desc: "Código" },
    { id: "nombre", desc: "Nombre colaborador" },
  ];
  //*States
  const [validated, setValidated] = useState(false);
  const [employeeListSelected, setEmployeeListSelected] = useState({});
  //*Redux
  const { copiaError } = useSelector((store) => store.monitorOnBoarding);
  const areas = useSelector((store) => store.areas.areas);
  const loadingAreas = useSelector((store) => store.areas.loading);
  const {
    loading,
    puestoloading,
    unidadloading,
    saveLoader,
    segmentLength,
    segment,
    puestoLength,
    puesto,
    unidadLength,
    unidad,
    segmentFormFail,
    loadingEmployees,
    employees,
  } = useSelector((store) => store.segment);

  //*variables
  const dispatch = useDispatch();
  const schema = Yup.object().shape({
    empleado: Yup.string().required("**Campo requerido"),
  });

  const [tipoBusqueda, setTipoBusqueda] = useState(filters[0]);
  //* Methods
  const _getEmployee = (value = "") => {
    dispatch(
      getEmployees({
        filter: value,
        tipo_busqueda: tipoBusqueda.id,
      })
    );
  };

  // useEffect(() => {
  //   if (props.item && props.item.unidad_organizativa) {
  //     setUnidadSeleccionado(props.item.list_unidad_organizativa[0]);
  //   }
  // }, [props.item]);

  useEffect(() => {
    dispatch(getEmployees({ filter: "" }));
  }, []);

  const onSubmit = (req) => {
    let unidTemp = JSON.parse(req.empleado);
    try {
      const existItem = props.employeeListSelected.find(
        (rowItem) => rowItem.id === unidTemp.id
      );
      if (existItem) {
        toastr.info("El colbaorador ya ha sido agregado", "", {
          progressBar: true,
          rtl: true,
        });
        return;
      }
    } catch (error) {
      toastr.info("El colaborador no es valido", "", {
        progressBar: true,
        rtl: true,
      });
      return;
    }
    props.setEmployeeListSelected([...props.employeeListSelected, unidTemp]);
    // setUnidSelected([]);
  };

  const handleRemoveUnid = (ind) => {
    const _unid = props.employeeListSelected.slice();
    _unid.splice(ind, 1);
    props.setEmployeeListSelected(_unid);
    // props.handleClose();
  };

  return (
    <Modal size="md" show={props.show} onHide={props.handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          <h4 className="font-weight-bold text-uppercase m-0">
            <i
              className="flex-wrap material-icons"
              style={{ fontSize: "2rem", marginTop: "-.5rem" }}
            >
              app_registration
            </i>
            &nbsp;Colaboradores
          </h4>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Card className="border-0">
          <Card.Body>
            <Row>
              <Col>
                {!!copiaError && (
                  <Alert variant="danger" className="mt-4 mb-1 mx-3">
                    {copiaError}
                  </Alert>
                )}
                <Formik
                  validationSchema={schema}
                  onSubmit={onSubmit}
                  initialValues={{
                    empleado: "",
                  }}
                >
                  {({
                    handleSubmit,
                    handleChange,
                    setFieldValue,
                    handleBlur,
                    values,
                    touched,
                    errors,
                  }) => (
                    <>
                      <Form
                        onSubmit={(e) => {
                          handleSubmit(e);
                          // setFieldValue("unidad_organizativa", "");
                        }}
                        noValidate
                        validated={validated}
                      >
                        <Row className="d-flex flex-wrap align-items-top">
                          <Col sm={10}>
                            <SearchOrganizationalUnit
                              id="empleado"
                              name="empleado"
                              getFuncionalAreas={_getEmployee}
                              handleBlur={handleBlur}
                              employees={employees}
                              setFieldValue={setFieldValue}
                              isInvalid={touched.empleado && errors.empleado}
                              isValid={touched.empleado && !errors.empleado}
                              label=""
                              placeholder="Empleados"
                              tipoBusqueda={tipoBusqueda}
                            />
                          </Col>
                          {loadingAreas ? (
                            <Col sm={1}>
                              <Spinner animation="border" size="sm" />
                            </Col>
                          ) : (
                            <OverlayTrigger
                              placement="auto"
                              overlay={
                                <Tooltip {...props}>
                                  Seleccionar Filtrado
                                </Tooltip>
                              }
                            >
                              <Dropdown>
                                <Dropdown.Toggle
                                  variant="light"
                                  className="btn-sm font rounded-pill"
                                >
                                  <i className="material-icons">filter_list</i>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  {filters.map((item) => (
                                    <Dropdown.Item
                                      onClick={() => setTipoBusqueda(item)}
                                      key={item.id}
                                    >
                                      {item.desc}
                                    </Dropdown.Item>
                                  ))}
                                </Dropdown.Menu>
                              </Dropdown>
                            </OverlayTrigger>
                          )}
                        </Row>
                        {touched.empleado && errors.empleado ? (
                          <small className="text-danger px-3">
                            {errors.empleado}
                          </small>
                        ) : (
                          <small className="px-3">
                            **Búsqueda por: Código o nombre del colaborador
                          </small>
                        )}
                        <Col className="mt-3 pl-1">
                          <Button
                            disabled={values.empleado === ""}
                            className="rounded-pill"
                            variant="primary"
                            type="submit"
                            // onClick={handleSubmit}
                          >
                            Agregar
                          </Button>
                        </Col>
                      </Form>
                    </>
                  )}
                </Formik>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col>
                <div>
                  {loadingAreas ? (
                    <div className="d-flex justify-content-center">
                      <Spinner
                        animation="border"
                        role="status"
                        className="d-flex justify-content-center"
                      />
                    </div>
                  ) : props.employeeListSelected.length > 0 ? (
                    // <Card>
                    <div class="table-responsive">
                      <Table striped>
                        <thead>
                          <tr>
                            <th>Código</th>
                            <th>Nombre</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {props.employeeListSelected.map((item, ind) => (
                            <tr key={item.id}>
                              <td>{item.codigo}</td>
                              <td>{item.nombre}</td>
                              <td>
                                <Button
                                  variant="default"
                                  size="sm"
                                  className="ml-3"
                                  onClick={() => handleRemoveUnid(ind)}
                                >
                                  <i
                                    className="material-icons"
                                    style={{ fontSize: "1.3rem" }}
                                  >
                                    delete
                                  </i>
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  ) : (
                    // </Card>
                    <Alert variant="info">
                      Aún no hay unidades agregadas a la tabla.
                    </Alert>
                  )}
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="rounded-pill"
          variant="secondary"
          onClick={props.handleClose}
        >
          Cancelar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default Employees;
